import React from "react";
import AboutUsHeader from "../../components/AboutUsHeader";
import AboutUsContent from "../../components/AboutUsContent";

const AboutUs = () => {
  return (
    <div style={{ minHeight: "84.6vh" }}>
      <AboutUsHeader />
      <AboutUsContent />
    </div>
  );
};

export default AboutUs;
